import { Fragment } from "react";
import YudlButton from "../../components/Button";
import PortfolioIntro from "./PortfolioIntro";
import Product from "./Product";

type PorfolioItem = {
  header: string;
  image: string;
  description: string;
  direction: "left-right" | "right-left";
  link: string;
};

const products: PorfolioItem[] = [
  {
    header: "Tracnine",
    link: "https://www.figma.com/proto/oqlF8I4OfbZJP0Z5kuDjhg/YUDL-Portfolio?page-id=758%3A15759&node-id=776%3A20283&viewport=644%2C551%2C0.08&scaling=min-zoom&starting-point-node-id=776%3A20283",
    description: "An on-demand logistics platform for individuals and businesses to manage, track and deliver parcels",
    direction: "left-right",
    image: "/assets/portfolio/tracnine.png",
  },
  {
    header: "Toursom",
    link: "https://www.figma.com/proto/oqlF8I4OfbZJP0Z5kuDjhg/YUDL-Portfolio?page-id=0%3A686&node-id=758%3A14750&viewport=373%2C515%2C0.31&scaling=min-zoom&starting-point-node-id=758%3A14750",
    description: "A web platform for booking personalised tour and vacation experiences across Africa.",
    direction: "right-left",
    image: "/assets/portfolio/toursom.png",
  },
  {
    header: "Konnect Africa",
    link: "https://www.figma.com/proto/oqlF8I4OfbZJP0Z5kuDjhg/YUDL-Portfolio?page-id=421%3A593&node-id=753%3A21441&viewport=602%2C517%2C0.18&scaling=min-zoom&starting-point-node-id=753%3A21441",
    description:
      "A global distribution system (GDS) for domestic flights in Nigeria, aimed at providing the best priced flight tickets to travel agents",
    direction: "left-right",
    image: "/assets/portfolio/konnect-africa.png",
  },
  {
    header: "Retrac",
    link: "#",
    description:
      "A resource management platform were recruitment agencies and organizations manage hiring process through a seamless user-centered tracking system.",
    direction: "right-left",
    image: "/assets/portfolio/retrac.png",
  },
  {
    header: "Blockoin",
    link: "https://www.figma.com/proto/oqlF8I4OfbZJP0Z5kuDjhg/YUDL-Portfolio?page-id=421%3A589&node-id=421%3A30810&viewport=1530%2C637%2C0.35&scaling=min-zoom&starting-point-node-id=421%3A30810",
    description: "A cryptocurrency wallet for digital nomads who which to make expenses with their crypto assets.",
    direction: "left-right",
    image: "/assets/portfolio/blockoin.png",
  },
  {
    header: "Connie",
    link: "#",
    description:
      "An AI powered dating app that helps its users find mates based on unique interest, activities and belief.",
    direction: "right-left",
    image: "/assets/portfolio/connie.png",
  },
];

const Portfolio = () => {
  return (
    <Fragment>
      <section className="portfolio-show-case">
        <PortfolioIntro />
      </section>
      <div className="d-flex justify-content-center">
        <div className="d-flex align-items-center mt-5 product-filter-container px-2 py-1">
          <span className="text-theme me-3">Select a project category</span>
          <select className="product-filter-select">
            <option value={""}>All Projects</option>
          </select>
        </div>
      </div>
      {products.map(({ direction, link, description, header, image }, i) => (
        <Product
          key={i}
          direction={direction}
          header={header}
          image={image}
          children={
            <div>
              <p>{description}</p>
              <div className="d-flex justify-content-start">
                <YudlButton buttonRole="anchor" children="View Prototype" link={link} />
              </div>
            </div>
          }
        />
      ))}
    </Fragment>
  );
};

export default Portfolio;
